import { TablePagination } from "@mui/material";
import { useTable } from "@xest-ui/data-table";
import React from "react";

function calculatePage(from, to, rowsPerPage, totalRows) {
  from = Math.max(1, from);
  to = Math.min(totalRows, to);

  const page = Math.ceil((from - 1) / rowsPerPage);

  return page;
}

function MyPaginator() {
  const {
    data: {
      goToFirstPage,
      goToNextPage,
      goToLastPage,
      goToPreviousPage,
      pageSize,
      metadata = { total: 0, from: 0, to: 0 },
      setPageSize,
    },
  } = useTable();
  const { total, from, to } = metadata;

  const currentPage = calculatePage(from, to, pageSize, total);

  const pageSizes = [5, 10, 25].concat(total > 25 ? total : []);
  return (
    <TablePagination
      component="div"
      count={total || 0}
      onPageChange={(e, page) => {
        if (page === 0) return goToFirstPage();
        if (total) {
          if (page === Math.floor(total / pageSize)) {
            goToLastPage();
          }
        }
      }}
      page={currentPage || 0}
      rowsPerPage={pageSize}
      rowsPerPageOptions={pageSizes}
      onRowsPerPageChange={(e) => {
        setPageSize(Number(e.target.value));
      }}
      showFirstButton
      showLastButton
      nextIconButtonProps={{
        onClick: goToNextPage,
      }}
      backIconButtonProps={{
        onClick: () => {
          goToPreviousPage();
        },
      }}
    />
  );
}

export default MyPaginator;
